import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

export default function LinkTo({
  children,
  href,
  as,
  replace,
  scroll,
  shallow,
  prefetch,
  locale,
  passHref,
  className = '',
  activeClassName,
  inactiveClassName,
  matchExact = false,
  ...anchorProps })
{
  const router = useRouter();

  const isActive = router.pathname === href ||
  !matchExact && router.pathname.startsWith(href);

  let newClassName = className;
  if (isActive && activeClassName) {
    newClassName += ` ${activeClassName}`;
  } else if (!isActive && inactiveClassName) {
    newClassName += ` ${inactiveClassName}`;
  }

  newClassName = newClassName.trim();

  return /*#__PURE__*/(
    React.createElement(Link, {

      href,
      as,
      replace,
      scroll,
      shallow,
      prefetch,
      locale,
      passHref },


    typeof children === 'function' ?
    children(isActive) : /*#__PURE__*/

    React.createElement("a", Object.assign({ className: newClassName }, anchorProps),
    children)));




}